<template>
  <div style=" background-color: #F8F9FB;padding: 0 60px;">
    <hhead></hhead>
    <div class="rz_body" :style="{ minHeight: MHeight }">
      <div class="left" :style="{ minHeight: MHeight }">
        <div>
          <img src="../../../../assets/images/crm/renzheng/xx.png" alt="" />
          <p>基本信息</p>
        </div>
        <div class="shu"></div>
        <div>
          <img src="../../../../assets/images/crm/renzheng/tz1.png" alt="" />
          <p>投资策略/理念</p>
        </div>
      </div>
      <div class="right" :style="{ minHeight: MHeight, padding: '0 70px' }">
        <div class="textarea_box">
          <label for="">
            <p>投资策略：</p>
            <textarea
              class="textarea"
              v-model="strategy"
              placeholder="请简述公司的投资策略"
            ></textarea>
          </label>

          <label for="">
            <p>投资理念：</p>
            <textarea
              class="textarea"
              v-model="idea"
              placeholder="请简述公司的投资理念"
            ></textarea>
          </label>
          <div class="btn_box">
            <div class="prev" @click="prev_btn">上一步</div>
            <div class="sub" @click="submit">提交认证</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hhead from '../../header/index';
import './style.css';
export default {
  components: { hhead },
  data() {
    return {
      MHeight: document.documentElement.clientHeight - 94 + 'px',
      strategy: '', //投资策略
      idea: '', //投资理念,
      msg: '',
    };
  },
  mounted() {
    if (this.$store.state.registerMsg) {
      this.msg = this.$store.state.registerMsg;
    } else {
      this.$router.push('/crm/authentication_t'); //如果刷新则返回上一步
    }
    if (this.$route.query.type) {
      this.$axios
        .post('/crm/ent/getAuthInfo', {
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          //   console.log(res);
          if (res.data.code == 403) {
            this.strategy = res.data.data.bizStrategy;
            this.idea = res.data.data.bizDirection;
          }
        });
    }
  },
  methods: {
    prev_btn() {
      //上一步
      this.$router.push('/crm/authentication_t');
    },
    submit() {
      //提交认证
      if (!this.$route.query.type) {
        this.$axios
          .post('/crm/ent/auth', {
            name: this.msg.qy_name,
            abbrName: this.msg.jc_name,
            code: this.msg.qy_register,
            codePic: this.msg.imgPath,
            applyDoc: this.msg.imgPath_t,
            createDate: this.msg.cl_time,
            initMoney: this.msg.capital,
            bizArea: this.msg.Range,
            bizDirection: this.idea,
            bizStrategy: this.strategy,
            apiToken: this.$store.state.usermsg.apiToken,
          })
          .then((res) => {
            //   console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.$router.push('/crm/index');
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              })
                .then(() => {
                  this.clear();
                })
                .catch(() => {});
            }
          });
      } else {
        this.$axios
          .post('/crm/ent/reauth', {
            name: this.msg.qy_name,
            abbrName: this.msg.jc_name,
            code: this.msg.qy_register,
            codePic: this.msg.imgPath,
            applyDoc: this.msg.imgPath_t,
            createDate: this.msg.cl_time
              .replace(/年/g, '/')
              .replace(/月/g, '/')
              .replace(/日/g, ''),
            initMoney: this.msg.capital,
            bizArea: this.msg.Range,
            bizDirection: this.idea,
            bizStrategy: this.strategy,
            apiToken: this.$store.state.usermsg.apiToken,
            id: this.$route.query.id,
          })
          .then((res) => {
            //   console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.$router.push('/crm/index');
            }
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/crm/authentication/authentication_s/index.vue